import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Иллюстрация экранов ученика (прототип FKS-12500): штриховая раскрытая книга или разворот альбома —
 * белые страницы с блоками фото. Разворот ждущего экрана «дышит» скелетоном, готового — акцентным блоком.
 * Цвет штриха — акцент через currentColor.
 */
@Component({
  selector: 'app-book-illustration',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block text-acc',
    '[class.w-55]': "size() === 'md'",
    '[class.w-31]': "size() === 'sm'",
    'aria-hidden': 'true',
  },
  template: `
    @if (variant() === 'spread') {
      <div
        class="grid aspect-3/2 w-full grid-cols-2 gap-0.5 rounded-[var(--r-xs)] bg-illus-page-line p-0.5
               shadow-[var(--shadow-spread)]"
      >
        <div class="grid place-items-center bg-illus-page p-3.5">
          <div
            [class]="
              pending()
                ? 'size-full rounded-[var(--r-compact)] bg-illus-cell motion-safe:animate-pulse'
                : 'size-full rounded-[var(--r-compact)] bg-illus-hero'
            "
          ></div>
        </div>
        <div class="grid place-items-center bg-illus-page p-3.5">
          <div
            [class]="
              pending()
                ? 'size-full rounded-[var(--r-compact)] bg-illus-cell motion-safe:animate-pulse'
                : 'size-full rounded-[var(--r-compact)] bg-illus-cell'
            "
            [style.animation-delay]="'var(--t-stagger)'"
          ></div>
        </div>
      </div>
    } @else {
      <svg
        class="h-auto w-full"
        viewBox="0 0 220 165"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M110 40v100" />
        <path d="M110 40c-22-14-50-14-78-6v100c28-8 56-8 78 6" />
        <path d="M110 40c22-14 50-14 78-6v100c-28-8-56-8-78 6" />
        <circle cx="68" cy="88" r="14" />
        <path d="M52 122c4-12 28-12 32 0" />
        <path d="M132 66h44M132 80h44M132 94h30" />
        <path d="M150 128l8 8 16-18" />
      </svg>
    }
  `,
})
export class BookIllustrationComponent {
  /** 'line' — книга штрихом на титульных экранах, 'spread' — разворот альбома на экранах ожидания и финала. */
  readonly variant = input<'line' | 'spread'>('line');
  /** Разворот ещё собирается: блоки серые и пульсируют. */
  readonly pending = input(false);
  /** 'md' — 220 px on full screens, 'sm' — 124 px in a card's picture column. */
  readonly size = input<'md' | 'sm'>('md');
}
